query SwitchesIndex(
  $first: Int
  $last: Int
  $after: String
  $before: String
  $query: String
  $queryList: [QueryItemInput!]
) {
  switches(
    first: $first
    last: $last
    after: $after
    before: $before
    query: $query
    queryList: $queryList
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    edges {
      cursor
      node {
        id
        insertedAt
        updatedAt
        name
        notes
        smsEnabled
        smsAuthMethod
        smsIdentity
        smsSecret
        smsProtocol
        smsMessageFormat
        smsEndpoints
        smsOptions {
          expiredToMailbox
          customHeaders {
            name
            value
          }
          customParams {
            name
            value
          }
        }
        mmsEnabled
        mmsAuthMethod
        mmsIdentity
        mmsSecret
        mmsProtocol
        mmsMessageFormat
        mmsEndpoints
        mmsOptions {
          expiredToMailbox
          customHeaders {
            name
            value
          }
          customParams {
            name
            value
          }
        }
        apiKey {
          id
          name
        }
        account {
          id
          name
          customerId
        }
      }
    }
  }
}
